import {TableBody, TableCell, TableRow} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import InputText from '../../components/forms/InputText';

const DeleteListBusinessItem = ({users, editable, setUsers}) => {
  const updateEmail = (id, value) => {
    setUsers(prevState => {
      return [
        ...prevState.map((a, index) => {
          if (index === id) {
            return {...a, 'E-mail': value};
          }
          return a;
        }),
      ];
    });
  };

  const deleteItem = id => {
    const usersFilter = users.filter((item, index) => index != id);
    setUsers(usersFilter);
  };

  return (
    <TableBody>
      {users.length ? (
        editable ? (
          <>
            {users.map((user, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <InputText
                    label=""
                    value={users[index]['E-mail']}
                    onChange={e =>
                      updateEmail(index, e.target.value.toString())
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </>
        ) : (
          users.map((user, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{user['E-mail']}</TableCell>
            </TableRow>
          ))
        )
      ) : (
        <TableRow>
          <td colSpan="5" className="text-center">
            Sem dados.
          </td>
        </TableRow>
      )}
    </TableBody>
  );
};

export default DeleteListBusinessItem;
